export default __webpack_public_path__ + "images/fd5b159b72ba62b9da8e4009fe404e2c.webp";